import { format } from 'date-fns'

type Props = {
  fromDate: Date
  toDate: Date
  type: 'ALL' | 'PER_FRAME'
  fileType?: 'csv' | 'zip'
  areaName?: string
}
export function generateContractExportFileName({
  fromDate,
  toDate,
  type,
  fileType = 'csv',
  areaName,
}: Props): string {
  const area =
    fileType === 'zip'
      ? 'perArea'
      : areaName !== undefined
        ? areaName
        : 'allArea'
  const period = `${format(fromDate, 'yyyyMM')}-${format(toDate, 'yyyyMM')}`
  const typeName = type === 'PER_FRAME' ? 'timeSpan' : 'total'
  const timestamp = format(new Date(), 'yyyyMMddHHmmss')
  return `${period}_${area}_${typeName}_${timestamp}.${fileType}`
}
